import { ProgramsSlideBtnArrowIcon } from './ArrowIcon'
import { ProgramsSlideBtnContainer } from './Container'

type Peops = {
  slideAction: () => void
}

export const ProgramsSlideBtn = ({ slideAction }: Peops): JSX.Element => {
  return (
    <ProgramsSlideBtnContainer>
      <button
        className="md:w-[2.3vw] md:h-[3vw] bg-[#F0B430] rounded-[4px] lg:hover:opacity-50"
        onClick={slideAction}
      >
        <ProgramsSlideBtnArrowIcon />
      </button>
    </ProgramsSlideBtnContainer>
  )
}
